export const theme = {
    emerald: {
        400: '#50c878',
        500: '#2eb67d',
    },
    mercury: {
        200: '#e4e4e4',
        300: '#e5e5e6',
        400: '#adadad',
        500: '#8a9192',
        950: '#363636',
    },
    gray: {
        100: '#f0f0f0',
        200: '#f5f5f5',
        300: '#e0e0e0',
        900: '#121212',
        '900-translucent': '#121212bf',
    },
    'primary-black': '#000000',
    'primary-white': '#ffffffff',

    'secondary-dark-grey': '#595959',
    'secondary-light-grey': '#bdbdbd',
    'secondary-off-white': '#efefef',

    'primary-black-75': 'rgba(0, 0, 0, 0.75)',
    'primary-black-50': 'rgba(0, 0, 0, 0.5)',
    'primary-black-25': 'rgba(0, 0, 0, 0.25)',

    'primary-white-75': 'rgba(255, 255, 255, 0.75)',
    'primary-white-50': 'rgba(255, 255, 255, 0.5)',
    'primary-white-25': 'rgba(255, 255, 255, 0.25)',

    'error-red': '#d32f2f',

    green: '168e16',

    transparent: 'transparent',
    white: '#ffffff',
    black: '#000000',
};
